import { t } from '@/i18n';

export const changePasswordFormSchemaMessages = {
  required: t('pages.profile.components.security_tab_content.schema.required'),

  minPasswordSize: t('pages.profile.components.security_tab_content.schema.required_min'),
  requiredPasswordCharacters: t('pages.profile.components.security_tab_content.schema.required_request'),
  invalidPasswordConfirmation: t('pages.profile.components.security_tab_content.schema.required_password'),
  nonDifferentNewPassword: t('pages.profile.components.security_tab_content.schema.required_newpass'),
};
